import { Flex } from '@/components';
import { AnalysisSearchSkeleton } from '@/features/search/_components/analysis/skelton/AnalysisSearchSkeleton';
import { ProjectsSearchAccordionInitializeStore } from '@/features/search/_stores/ProjectsSearchAccordionInitializeStore';
import { useProjectsSearchStore } from '@/features/search/_stores/projects-search-store';
import type { FC } from 'react';
import { AnalysisSegmentSwitcher } from '../../_components/AnalysisSegmentSwitcher';
import { AnalysisSheetTypeProvider } from '../../_hooks/useAnalysisSheetType';
import { KsAnalysisResults } from '../_components/KsAnalysisResults';
import { KsAnalysisSearchAccordion } from '../_components/KsAnalysisSearchAccordion';
import { useFundSheetAnalysisPageSearchQueryStates } from '../_hooks/search-query-states';

/**
 * 基金シート分析ページ (`/analysis/fund-sheet`)。
 *
 * RS 用 `AnalysisPage` は `AnalysisResults` (useProjectAnalysis を発火) まで含むため、
 * KS では使わず KS 専用に組み立てる。
 */
export const FundSheetAnalysisPage: FC = () => {
  const { searchQueryStates, isDebouncing } =
    useFundSheetAnalysisPageSearchQueryStates({ useDebounceControl: true });
  const { isLoading } = useProjectsSearchStore();
  return (
    <AnalysisSheetTypeProvider value="KS">
      <Flex vertical gap={16}>
        <AnalysisSegmentSwitcher segment="fund-sheet" />
        <ProjectsSearchAccordionInitializeStore
          type="analysis"
          searchQueryStates={searchQueryStates}
          isDebouncing={isDebouncing}
        />
        {isLoading ? (
          <AnalysisSearchSkeleton />
        ) : (
          <>
            <KsAnalysisSearchAccordion />
            <KsAnalysisResults />
          </>
        )}
      </Flex>
    </AnalysisSheetTypeProvider>
  );
};
